var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"get-bg"},[_c('img',{attrs:{"src":require("common/image/vip-logo.png"),"alt":""}}),_vm._v("升级会员 · "),_c('span',[_vm._v("2000+微课免费学习")]),_vm._v(" "),_c('router-link',{staticClass:"vip-btn",attrs:{"tag":"div","to":"/vip"}},[_vm._v("开通会员")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42667248","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/get-vip.vue
// module id = null
// module chunks = 